export default "__VITE_ASSET__8721cc67__"